import { useNavigate } from "react-router-dom";

import { AccordionList } from "molecules/accordion-list/AccordionList";

export interface RetailProductOrderActionsProps {
  cancelEligibilityExpired?: boolean;
  refundDescription?: string;
  orderId?: string;
  hasPickupItems?: boolean;
  hasShippingItems?: boolean;
  showNeedHelp?: boolean;
}

export const RetailProductOrderActions = ({
  cancelEligibilityExpired,
  refundDescription,
  orderId,
  hasPickupItems = false,
  hasShippingItems = false,
  showNeedHelp = true,
}: RetailProductOrderActionsProps) => {
  const navigate = useNavigate();

  const handleNeedHelpClick = () => {
    if (orderId) {
      navigate(`/products/order/${orderId}/return`);
    } else {
      navigate(-1);
    }
  };

  const handleFaqClick = () => {
    const params = new URLSearchParams();
    if (hasPickupItems) {
      params.append("hasMyProduct", "true");
    }
    if (hasShippingItems) {
      params.append("hasSkinDrop", "true");
    }
    const queryString = params.toString();
    navigate(`/faqs${queryString ? `?${queryString}` : ""}`);
  };

  return (
    <div className="rounded-lg bg-white shadow-subtle">
      <AccordionList
        items={[
          {
            title: "FAQs",
            onClick: handleFaqClick,
            titleClassName: "text-body2",
          },
          ...(showNeedHelp
            ? [
                {
                  title: "Need Help?",
                  disabled: cancelEligibilityExpired,
                  description: refundDescription,
                  onClick: handleNeedHelpClick,
                  titleClassName: "text-body2",
                },
              ]
            : []),
        ]}
      />
    </div>
  );
};
